
export default {
  name: 'TutorialSuggestedBlogSection',
  props: {
    data: {
      type: Object,
      default: () => ({
        title: '瀏覽此頁面的人，也瀏覽...',
        ButtonText: '查看更多',
        ButtonLink: 'https://google.com',
        mode: '1'
      }),
    },
    blogData: {
      type: Array,
      default: () => ([]),
    }
  },
  data() {
    return { 
      activeItemId: 0,
      backgroundImg: 'cross-selling-banner-tutorial.png'
    }
  },
  computed: {  
  },
  methods: {
    toggleActiveItem(i) {
      if (i === this.activeItemId) {
        this.activeItemId = -1
      } else {
        this.setActiveItem(i)
      }
    },

    setActiveItem(i) {
      this.activeItemId = i
    }
  },
}
